import { Component, Input, OnDestroy } from "@angular/core";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { Subject, timer } from "rxjs";
import { debounce, distinctUntilChanged } from "rxjs/operators";

import { DestroyableMixin } from "../../mixins/destroyable.mixin";

@Component({
    selector: "pcg-ng-spinner",
    templateUrl: "./spinner.component.html"
})
export class SpinnerComponent extends DestroyableMixin(EmptyInstance) implements OnDestroy {
    public state: boolean;

    private _stateSubject = new Subject<boolean>();

    public get show(): boolean {
        return this.state;
    }

    @Input()
    public set show(state: boolean) {
        this._stateSubject.next(Boolean(state));
    }

    @Input()
    public size: "large" | "medium" | "small" = "large";

    public constructor() {
        super();
        this._stateSubject
            .pipe(
                debounce(state => timer(state ? 250 : 0)),
                distinctUntilChanged()
            )
            .subscribe(state => this.state = state);
    }

    public ngOnDestroy(): void {
        this.destroy();
    }
}
